const API_PATHS = {
  BASE_PATH: 'https://api.tvmaze.com/shows',
  EPISODES_PATH: '/episodes',
  EPISODES_BY_NUMBER_PATH: '/episodebynumber',
  SEASON_PARAM: 'season=',
  NUMBER_PARAM: 'number=',
};

export default API_PATHS;
